import * as React from "react";
import { Column } from "primereact/column";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { DropdownFilterElement, renderHeader } from "../../components/TableUtils";
import { printLabels } from "../../utils/content";
import { DeviceLabelList } from "../../components/Barcode";
import { useAuth0 } from "../../auth/react-auth0-wrapper"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { text } from "@fortawesome/fontawesome-svg-core";
import { deleteDevice } from "../../api/devices";
import Can from "../../auth/Can";
import roles from "../../auth/roles";

export default function DeviceList() {
  let dtable;
  const [openLabels, setOpenLabels] = React.useState();
  const { domains } = useAuth0();
  const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("devices", "createdat desc", undefined, "");

  const [openModal, setOpenModal] = React.useState(false);
  const toggle = () => setOpenModal(!openModal);

  const onDelete = async id => {
    const value = await deleteDevice(id);
    toggle();
    forceRefresh();
    return value;
  };

  const modalSection = () => (
    <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
      <ModalHeader toggle={toggle}>
        Eliminazione Dispositivo
      </ModalHeader>
      <ModalBody>
        <p>Confermi di voler eliminare il Dispositivo con IMEI {openModal.imei}?</p>
      </ModalBody>
      <ModalFooter>
        <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
        <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
      </ModalFooter>
    </Modal>
  );

  const printLabelsSection = () => (
    <Modal centered isOpen={openLabels ? true : false} backdrop={true}>
      <ModalHeader toggle={() => setOpenLabels(null)}>
        Stampa Etichette
      </ModalHeader>
      <ModalBody>
        <DeviceLabelList
          id="labelsToPrint"
          items={openLabels ? [openLabels] : []}
        />
      </ModalBody>
      <ModalFooter>
        <div className="float-right mt-5">
          <Button
            className="p-button-success p-button-icon-only"
            onClick={() => printLabels("labelsToPrint")}
          >
            <i className="pi pi-print"></i>
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );

  const getHeader = () => {
    return (
      <div className="action-container">
        <Link className="btn btn-primary p-button-icon-only" to={`add-device`} title="Aggiungi dispositivo">
          <i className="pi pi-plus mr-2"></i>Nuovo Dispositivo
        </Link>
        <Link
          title="Importa dispositivi"
          className="btn btn-primary p-button-icon-only"
          to={`import-devices`}
        >
          <i className="pi pi-download mr-2"></i>Importazione Dispositivi
        </Link>
      </div>
    );
  };

  const onRefresh = () => {
    forceRefresh();
    setGlobalFilter("");
  }

  const exportTable = () => {
    dtable.exportCSV();
  }

  return (
    <PageLayout title="Elenco Dispositivi">
      <Row>
        <Col>
          <DataTable
            ref={el => {
              dtable = el;
            }}
            loading={loading}
            value={result}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            className="p-datatable-hoverable-rows p-datatable-customers"
            responsive
            paginator={true}
            autoLayout={false}
            first={0}
            rows={50}
            totalRecords={result.length}
            paginatorPosition="both"
            globalFilter={globalFilter}
            header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
            emptyMessage={() => (<div className="text-center">Nessun dispositivo in tabella</div>)}
            paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            currentPageReportTemplate="Visualizzati {first} di {last} Dispositivi su un totale di {totalRecords}"
          >
            <Column
              field="imei"
              style={{ wordWrap: "break-word" }}
              header="IMEI"
              sortable
              filter
              filterMatchMode="contains"
              body={(rowData, column) => {
                return (
                  <Link
                    to={`devices/${rowData._id}`}
                  >
                    {rowData.imei}
                  </Link>
                );
              }}
            />
            <Column
              field="serial"
              style={{ wordWrap: "break-word" }}
              header="Numbero seriale"
              sortable
              filter
              filterMatchMode="contains"
            />
            <Column
              field="number"
              sortable
              filter
              style={{ wordWrap: "break-word" }}
              header="Telefono"
            />
            <Column
              field="attributes.model"
              header="Modello"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="attributes.type"
              header="Tipo"
              sortable
              filterElement={
                <DropdownFilterElement
                  field="attributes.type"
                  options={domains.devicesType}
                  onChange={(opt) => {
                    dtable.filter(opt.value, opt.field, opt.type);
                  }}
                />
              }
              body={(row) => domains.devicesType.find(el => el.value === row.attributes.type).label}
              filter
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="attributes.rifInvoice"
              header="Fattura"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="tenant"
              header="Dealer"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="customer"
              header="Cliente"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="plate"
              header="Targa"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="status"
              header="Stato"
              sortable
              filter
              style={{ wordWrap: "break-word", textAlign: "center" }}
              filterElement={
                <DropdownFilterElement
                  field="status"
                  options={domains.devicesStatus}
                  onChange={(opt) => {
                    dtable.filter(opt.value, opt.field, opt.type);
                  }}
                />
              }
              body={(rowData, column) => {
                return (
                  <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status}</span>
                );
              }}
            />
            <Column
              field="actions"
              body={(rowData, column) => {
                return (
                  <div className="action-container">
                    <Link
                      title="Gestisci dispositivo"
                      className="btn btn-sm btn-primary p-button-icon-only"
                      to={`devices/${rowData._id}`}
                    >
                      <i className="pi pi-pencil"></i>
                    </Link>
                    {rowData.status !== "inserito" && (
                      <Button
                        className="btn btn-sm btn-secondary p-button-icon-only"
                        onClick={() => setOpenLabels(rowData)}
                      >
                        <FontAwesomeIcon icon={faBarcode} />
                      </Button>
                    )}
                    <Can
                      roles={[roles.ADMIN]}
                      yes={() => (
                        <Button
                          color="danger"
                          title="Elimina dispositivo"
                          onClick={() => setOpenModal(rowData)}
                          className="btn-sm p-button-icon-only"
                        >
                          <FontAwesomeIcon icon="trash-alt" />
                        </Button>
                      )}
                      no={() => null}
                    />
                  </div>
                );
              }}
              style={{ wordWrap: "break-word" }}
            />
          </DataTable>
        </Col>
      </Row>
      {printLabelsSection()}
      {modalSection()}
    </PageLayout >
  );
}
